export default "__VITE_ASSET__DoExvbsm__"